import { render, staticRenderFns } from "./notification-sidebar.vue?vue&type=template&id=78279c1b&scoped=true"
import script from "./notification-sidebar.vue?vue&type=script&lang=ts"
export * from "./notification-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./notification-sidebar.vue?vue&type=style&index=0&id=78279c1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78279c1b",
  null
  
)

export default component.exports